import produce from "immer";
import { TRIGGER_TOAST, RESET_TOAST } from "../constants";
const reducerInitialState = {
  isLoading: false,
  showToast: false,
  toastSeverity: 'error',
  toastTransMessage: "message_errorDefault"
};


const toaster = (state=reducerInitialState, action: any) => {
  switch (action.type) {
      case TRIGGER_TOAST:
      case RESET_TOAST:
      return produce(state,(draftState: any)=>{
          draftState.showToast = action.payload.shouldShow;
          draftState.toastSeverity = action.payload.severity;
          draftState.toastTransMessage = action.payload.transMessage;
      })
      default:
        return state;
  }
}

export default toaster;
